export default {
      id: "pushpay-logo-grey-2-usage",
      viewBox: "0 0 1200 335.8",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pushpay-logo-grey-2",
      toString: function () {
        return this.url;
      }
    }